export default __webpack_public_path__ + "static/media/tiempos.87a20a4c.jpeg";